// TODO: Break down state into different modules

module.exports = {
    mockState(context = "text") {
        let state = {
            messageType: "",
            audioType: "",
            contactListType: "",
            lists: [],
            listsFull: [],
            callers: [],
            selectedCaller: 1,
            selectedList: null,
            recording: null,
            message: "",
            callerName: "",
            recordings: [],
            callerPhoneNumber: "",
            file: null,
            frequency: 40,
            startDate: "",
            startTime: "",
            audioUploadType: "",
            jobId: "",
            status: "",
            token: localStorage.getItem("token") || "",
            user: {},
            currentCampaignId: "",
            campaigns: [],
        };

        if(context === "text") {
            state.messageType = "sms";
            state.contactListType = "existing_list";
            state.message = "Lorem Ipsum";
            state.selectedCaller = 1;
            state.selectedList = 1;
        }
        else if (context === "voice") {
            state.messageType = "audio";
            state.audioType = "voice";
            state.contactListType = "existing_list";
            state.selectedCaller = 1;
            state.selectedList = 1;
            state.recording = 3;
            state.audioUploadType = "Audio File";

        }
        else if (context === "voicemail") {
            state.messageType = "audio";
            state.audioType = "voicemail";
            state.contactListType = "existing_list";
            state.selectedCaller = 1;
            state.selectedList = 1;
            state.recording = 3;
            state.audioUploadType = "Audio File";
        }

        return state;
    }
}